import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const tankVolumeCapacityExceededHardRule: StowageRuleBM = {
    id: StowageRuleId.TankVolumeCapacityExceededHardRule,
    name: 'The stowed volume cannot exceed the tank volume capacity.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content volume',
                            fieldPath: 'getTankContentVolume',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Tank volume',
                            fieldPath: 'tank.volume',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Tank volume capacity exceeded',
    },
};
